var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_iteminfo"},[_c('div',{staticClass:"jieshao",domProps:{"innerHTML":_vm._s(_vm.info.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }